module.exports = __webpack_public_path__ + "static/media/PaketA.f55796a3.jpeg";